import React from 'react'
import { motion } from 'framer-motion'
import { useAppStore } from '@/hooks/useAppStore'
import { EmberField } from '@/components/shared/EmberField'

// Dedicated mode-select screen — the candlelit chapel's own quiet threshold
// between the landing and the guide's questions. Voice is honestly marked
// COMING SOON and is non-interactive; Tap & Type proceeds to the quiz.
export function ModeScreen() {
  const setScreen = useAppStore((s) => s.setScreen)

  return (
    <div style={{ minHeight: '100vh', background: 'var(--void)', position: 'relative', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 50% 0%, rgba(201,151,58,0.08) 0%, transparent 55%), linear-gradient(180deg, #081C10 0%, #050E08 100%)', pointerEvents: 'none' }} />
      <EmberField count={16} />

      {/* Header */}
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 24px' }}>
        <div>
          <div style={{ fontFamily: 'var(--serif-caps)', fontSize: 16, letterSpacing: '0.14em', color: 'var(--candle2)', textTransform: 'uppercase' }}>Sanctum</div>
          <div style={{ fontFamily: 'var(--serif-body)', fontSize: 9, color: 'var(--ivory-faint)', letterSpacing: '0.1em', fontStyle: 'italic', marginTop: -2 }}>by Imaginarium</div>
        </div>
        <button onClick={() => setScreen('welcome')} style={{ fontFamily: 'var(--serif-caps)', fontSize: 10, letterSpacing: '0.08em', color: 'var(--candle)', background: 'transparent', border: `1px solid var(--hairline2)`, padding: '6px 14px', cursor: 'pointer', textTransform: 'uppercase' }}>
          ← Back
        </button>
      </div>

      {/* Body */}
      <div style={{ position: 'relative', flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px 24px 60px', textAlign: 'center' }}>
        <div style={{ fontFamily: 'var(--serif-caps)', fontSize: 10, letterSpacing: '0.2em', color: 'var(--ivory-faint)', textTransform: 'uppercase', marginBottom: 14 }}>
          Welcome to Sanctum
        </div>
        <motion.h1 initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
          style={{ fontFamily: 'var(--serif-caps)', fontSize: 'clamp(26px, 5vw, 42px)', color: 'var(--ivory)', letterSpacing: '0.03em', marginBottom: 14, maxWidth: 720 }}>
          How would you like to be guided?
        </motion.h1>
        <p style={{ fontFamily: 'var(--serif-body)', fontSize: 15, color: 'var(--ivory-dim)', fontStyle: 'italic', marginBottom: 40 }}>
          Our guide will discover the sacred path that calls you.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 18, width: '100%', maxWidth: 720 }}>
          {/* Speak — coming soon, non-interactive */}
          <div style={{
            position: 'relative', background: 'rgba(248,245,239,0.03)', border: `1px solid var(--hairline)`,
            padding: '36px 24px', cursor: 'not-allowed', opacity: 0.62,
          }}>
            <div style={{ position: 'absolute', top: 14, right: 14, fontFamily: 'var(--serif-caps)', fontSize: 8, letterSpacing: '0.12em', color: 'var(--void)', background: 'var(--candle2)', padding: '3px 9px', textTransform: 'uppercase' }}>
              Coming Soon
            </div>
            <div style={{ width: 56, height: 56, borderRadius: '50%', border: `1px solid var(--hairline2)`, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 18px', fontSize: 22 }}>
              🕯
            </div>
            <div style={{ fontFamily: 'var(--serif-caps)', fontSize: 18, color: 'var(--ivory)', letterSpacing: '0.05em', marginBottom: 8 }}>Speak</div>
            <div style={{ fontFamily: 'var(--serif-body)', fontSize: 13, color: 'var(--ivory-faint)', fontStyle: 'italic', lineHeight: 1.6 }}>
              Speak your calling aloud, and Sanctum will listen. A future rite, not yet ready to receive your voice.
            </div>
          </div>

          {/* Tap & Type — active */}
          <motion.div whileHover={{ y: -3 }} onClick={() => setScreen('quiz')}
            style={{
              position: 'relative', background: 'rgba(201,151,58,0.06)', border: `1px solid var(--hairline2)`,
              padding: '36px 24px', cursor: 'pointer', boxShadow: '0 0 24px rgba(201,151,58,0.1)',
            }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', border: `1px solid var(--candle)`, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 18px', fontSize: 22, color: 'var(--candle2)', boxShadow: '0 0 16px rgba(201,151,58,0.35)' }}>
              ✦
            </div>
            <div style={{ fontFamily: 'var(--serif-caps)', fontSize: 18, color: 'var(--ivory)', letterSpacing: '0.05em', marginBottom: 8 }}>Tap &amp; Type</div>
            <div style={{ fontFamily: 'var(--serif-body)', fontSize: 13, color: 'var(--ivory-dim)', fontStyle: 'italic', lineHeight: 1.6, marginBottom: 16 }}>
              Choose considered answers or write freely. Quiet, unhurried, entirely your own pace.
            </div>
            <div style={{ display: 'inline-block', fontFamily: 'var(--serif-caps)', fontSize: 9, letterSpacing: '0.12em', color: 'var(--candle2)', border: `1px solid var(--hairline2)`, padding: '4px 12px', textTransform: 'uppercase' }}>
              Touch · Text
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  )
}
